import { Injectable } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { MenuNaviService } from 'src/app/utils/menu-navi.service';
import { TraductionService } from 'src/app/utils/traduction.service';
import { ToolsService } from '../../utils/tools.service';
import { UserContact } from '../Contact/user-contact';
import { ModulesManagerService } from '../Module/modules-manager.service';
import { TermsPage } from 'src/app/Modales/Terms/terms/terms.page';
import { Ask } from '../Ask/ask.service';
import { StatsCalculator } from '../StatsCalculator/stats-calculator';
import { LoggerService } from '../../utils/logger.service';

@Injectable()
export class UserService {
  private Id: number = -1;
  private Invited: Boolean = false;
  private IsAdmin: Boolean = false;
  private manager: ModulesManagerService
  private Loged: Boolean = false;
  private FirstName: string = ""
  private LastName: string = ""
  private CguUpToDate: Boolean = false
  private Email: string = ""
  private DisconnectTime = 0;
  private PhoneNumber: string = ""
  private Language: string = "fra";
  private Society: string = "";
  private DisplayPhoneNumber: boolean = false;
  private CreatedDate: number = new Date().getTime();
  private onLoads: Array<any> = [];
  private trad: TraductionService;
  private StatsCalculator: StatsCalculator;

  constructor(private navi: MenuNaviService, private tools: ToolsService, private actionSheetCtrl: ActionSheetController) {
  }

  initiate(manager: ModulesManagerService) {
    this.manager = manager
    manager.Ws.AddEvent("UserConnection", "Connect", (event) => {
      if (this.manager.Navi.isSelected("welcome") || this.manager.Navi.isSelected("login") || this.manager.Navi.isSelected("register")) {
        this.manager.Navi.navigateTo("/asks")
      }
      this.loadData(event)
    })
    manager.Ws.AddEvent("UserConnection", "Update", (event) => { this.hydrate(event.Data) })
    manager.Ws.AddEvent("UserConnection", "Disconnect", (event: any) => {
      if (event.Data.forced) this.manager.Tool.notify(this.manager.Trad.Parse("STR_SERVER_SHUTDOWN"))

      this.Logout(false, true)
    })
  }

  get UserStats(): StatsCalculator {
    return this.StatsCalculator
  }

  get CguIsAccepted() {
    if (!this.isLoged) return false
    return this.CguUpToDate
  }

  get UserId(): number {
    return this.Id;
  }

  set Trad(value: TraductionService) {
    this.trad = value;
  }

  get LanguageUser(): string {
    return this.Language;
  }

  set LanguageUser(value: string) {
    if (this.isLoged && this.Language != value)
      this.manager.Ws.Send("Users", "Update", { type: "language", Language: value }, false)
    this.Language = value;
    this.navi.closeMenu()
  }

  setLanguageUser(language) {
    this.LanguageUser = language;
  }

  public async presentLanguageActionSheet() {
    const actionSheet = await this.actionSheetCtrl.create({
      buttons: this.buttons()
    }
    )
    await actionSheet.present();
  }

  private buttons() {
    let buttons = [];
    for (let libelle of this.trad.LanguageAvaible()) {
      let button = {
        text: libelle,
        handler: () => {
          this.setLanguageUser(libelle)
        },
        cssClass: 'uppercase',
        icon: 'assets/flags/' + this.trad.getFlagCode(libelle) + '.svg'
      };
      buttons.push(button);
    }
    let button = {
      text: this.trad.Parse('STR_CANCEL'),
      role: 'cancel'
    }
    buttons.push(button);
    return buttons;
  }

  DefaultValue() {
    this.LanguageUser = "fra";
    this.InvitedUser = false;
    this.Loged = false;
    this.FirstName = "";
    this.LastName = "";
    this.Email = "";
    this.PhoneNumber = "";
    this.LanguageUser = "fra";
    this.DisplayPhoneNumber = false;
    this.CreatedDate = new Date().getTime();
    this.Id = -1
    this.DisconnectTime = 0
    this.IsAdmin = false
  }

  get DisconnectTimeUser() {
    return this.DisconnectTime
  }

  get isLoged(): Boolean {
    return this.Loged;
  }

  get HasAdminRight(): Boolean {
    return this.IsAdmin;
  }

  Logout(navigateToHome: boolean = true, askedByServer: boolean = false) {
    if (!askedByServer) {
      window.localStorage.LastConnectEmail = ""
      this.manager.Ws.Send("Users", "Disconnect", {}, false)
    }
    this.manager.purge()
    this.manager.logOutOneSignal()
    this.DefaultValue()
    if (navigateToHome) {
      this.manager.LoadList("Asks")
      this.navi.navigateTo("/welcome")

    }
  }

  get isInvited(): Boolean {
    if (!this.Loged) return true
    return this.Invited
  }

  set InvitedUser(value: Boolean) {
    //if(this.isInvited)return
    this.Invited = value;
  }

  get FirstNameUser(): string {
    if (this.isInvited) return this.trad.Parse("STR_ANONYMOUS");
    return this.tools.capitalizeFirstChar(this.FirstName);
  }

  set FirstNameUser(value: string) {
    if (this.isInvited) return
    this.FirstName = value;
  }

  get DisplayUserPhoneNumber(): boolean {
    return this.DisplayPhoneNumber
  }

  set DisplayUserPhoneNumber(value: boolean) {
    this.DisplayPhoneNumber = value;
  }

  get LastNameUser(): string {
    if (this.isInvited) return this.trad.Parse("STR_ANONYMOUS");
    return this.tools.capitalizeFirstChar(this.LastName);
  }

  get ShortName() {
    if (this.isInvited) return '';
    return (this.tools.extractChar(this.tools.capitalizeFirstChar(this.FirstName)) + this.tools.extractChar(this.tools.capitalizeFirstChar(this.LastName)) || this.tools.extractChar(this.tools.capitalizeFirstChar(this.trad.Parse("STR_ANONYMOUS"))))
  }

  set LastNameUser(value: string) {
    this.LastName = value;
  }

  get EmailUser(): string {
    return this.Email;
  }

  set EmailUser(value: string) {
    this.Email = value;
  }

  get SocietyUser(): string {
    return this.Society;
  }

  set SocietyUser(value: string) {
    this.Society = value;
  }

  get UserName(): string {
    if (this.isInvited) return this.trad.Parse("STR_ANONYMOUS");
    return this.FirstName + " " + this.LastName
  }

  get DisplayedPhoneNumber(): string {
    return this.DisplayPhoneNumber ? this.PhoneNumber : ""
  }

  get Phone(): string {
    return this.PhoneNumber
  }

  set Phone(value: string) {
    this.PhoneNumber = value
  }

  public async loadData(event) {
    if (this.Id != event.Data.Id)
      this.Logout(false, true)
    this.hydrate(event.Data)

    this.manager.LoadList("Asks")
    this.Loged = true
    await this.manager.GetModuleData("UsersContacts", 0)
    this.StatsCalculator = new StatsCalculator(this.manager, "Users", this.Id)
    this.manager.logIntoOneSignal(this.Email)
    this.runOnLoad()

  }

  public onLoaded(event) {
    this.onLoads.push(event)
  }

  private runOnLoad() {
    for (const onLoad of this.onLoads)
      onLoad()
  }

  private hydrate(Data) {
    for (const [propertie, value] of Object.entries(Data))
      switch (propertie) {
        case "IsAnonyme":
          this.Invited = value as boolean
          break;
        case "IsActive":
          break;
        default:
          this[propertie] = value
          break;
      }
    this.SaveLocal()
  }

  get Contacts(): Array<UserContact> {
    return this.manager.GetListModuleData("UsersContacts").sort((a: UserContact, b: UserContact) => {
      if (a.LastName === b.LastName) {
        if (a.FirstName < b.FirstName) return -1
        if (a.FirstName > b.FirstName) return 1
      } else {
        if (a.LastName < b.LastName) return -1
        if (a.LastName > b.LastName) return 1
      }
      return 0;
    })
  }

  private async SaveLocal() {
    let resu = await this.manager.Sqli.executeSql("select * from users where Email= ? ", [this.Email]).catch((e) => {
      LoggerService.error("UserService executeSql error:", e)
      return []
    })
    if (resu.length) {
      await this.manager.Sqli.executeSql("update users set Id=?, FirstName=?, LastName=? , PhoneNumber=?, Society=? , Language=? , DisplayPhoneNumber=? where Email=?", [this.Id, this.FirstName, this.LastName, this.PhoneNumber, this.Society, this.Language, this.DisplayPhoneNumber, this.Email]).catch(LoggerService.error)
    } else {
      await this.manager.Sqli.executeSql("insert into users (Id, FirstName,LastName,PhoneNumber, Society,Language,DisplayPhoneNumber, Email  ) values (?,?,?,?, ?,?,?, ?)", [this.Id, this.FirstName, this.LastName, this.PhoneNumber, this.Society, this.Language, this.DisplayPhoneNumber, this.Email]).catch(LoggerService.error)
    }
  }

  public async isAcceptedCgu() {
    if (this.CguIsAccepted) return true
    this.CguUpToDate = await (new Promise<boolean>(async (handler) => {
      await this.viewCgu(handler)
    }))
    return this.CguUpToDate
  }

  public async viewCgu(handler = null) {
    await this.manager.displayModal({
      component: TermsPage,
      componentProps: {
        handler: handler
      },
      cssClass: "transparent-modal"
    })
  }
}
